import { FC, useCallback, useState } from 'react';
import modalClasses from '../../asset/css/common-modal.module.css';
import classes from '../../asset/css/change-delivery-date-modal/modal.module.css';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker, { registerLocale } from 'react-datepicker';
import ja from 'date-fns/locale/ja';
import { DeliveryDateType } from '../../types/delivery-date-type';
import { CommonModal } from '../CommonModal';

registerLocale('ja', ja);

export const ChangeDeliveryDateModal: FC<{
  active: boolean;
  scrollOffset: number;
  deliveryDate: DeliveryDateType;
  changeDeliveryDateFunc: (value: Date) => void;
  updateDeliveryDateFunc: () => void;
  closeFunc: () => void;
}> = ({ active, scrollOffset, deliveryDate, changeDeliveryDateFunc, updateDeliveryDateFunc, closeFunc }) => {
  const changeDeliveryDateHandler = useCallback(
    (value) => {
      changeDeliveryDateFunc(value);
    },
    [changeDeliveryDateFunc]
  );

  const clickSubmitBtnHandler = useCallback(() => {
    updateDeliveryDateFunc();
  }, [updateDeliveryDateFunc]);

  const content = (
    <>
      <h2>次回お届け日の変更</h2>
      <form className={classes.mypage_popup_cycle_form}>
        <div>
          <h3>ご希望のお届け日</h3>
          <DatePicker
            locale="ja"
            dateFormat="yyyy/MM/dd"
            selected={deliveryDate.deliveryDate}
            disabledKeyboardNavigation
            filterDate={(date) => !deliveryDate.disableWeek[date.getDay()]}
            onChange={changeDeliveryDateHandler}
          />
        </div>
        <button type="button" className={modalClasses.mypage_popup_ok} onClick={clickSubmitBtnHandler}>
          変更する
        </button>
      </form>
    </>
  );

  return <CommonModal active={active} scrollOffset={scrollOffset} closeFunc={closeFunc} content={content} />;
};
